export default "__VITE_ASSET__CugzddBj__"